<div class="wrap" [class.visible]="visible()" [class.hasresults]="hasResults()" [class.searching]="searching()" [class.navigating]="keyboardNavigationIndex() > -1">
  <div class="input-btn-white">
    <input aria-label="Seitenweite Suche" #searchInput name="gea-shop-search" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="off" type="search" [disabled]="! visible()" [(ngModel)]="sword" (keyup)="onKeyUp($event)" />
    @if (sword.length) {
      <svg (click)="clear()"
        width="24" height="24" viewBox="0 0 24 24" fill="none" class="close"
      >
        <path d="M18 6L6 18" stroke="#A49F9B" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="#A49F9B" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    }
    <a (click)="toggle()" class="nav-link" title="Suche">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
        <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.667 25.333c5.89 0 10.666-4.775 10.666-10.666S20.558 4 14.667 4 4 8.776 4 14.667c0 5.89 4.776 10.666 10.667 10.666ZM28 28l-5.8-5.8"/>
      </svg>
    </a>
  </div>
</div>